<template>
  
  <v-container fluid grid-list-lg>
    <v-layout row align-center  justify-center mx-1 py-0>
              <p>Already have an account? <router-link to="/" class="text-button">Sign in here</router-link> </p>
              
            </v-layout>          
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        
        <v-alert  :value="true"  v-if="error != null" type="error" v-html="error.message"></v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First Name *" required ></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last Name *"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="username" :rules="usernameRules" type="email" label="Email Address *" required ></v-text-field>
              </v-flex>
            </v-layout>

             <v-layout row>
                <v-flex xs12 sm2>Date of Birth*</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="Day"
                    v-model="dobDay"
                    required
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 >
                  <v-select
                    :items="months"
                    label="Month"
                    v-model="dobMonth"
                    outline
                    required
                    item-text="label" 
                    item-value="value" 
                  ></v-select>
                  </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="years"
                    label="Year"
                    v-model="dobYear"
                    :rules="dobValidation"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <p class="font-grey">Please supply an accurate date of birth to receive exclusive content on your birthday.</p> 
            
              <v-layout row v-show="this.parentalConsentRequired === true">
              <v-flex xs12 pb-0>
                <p>
                  You are under 13 years of age. Please ask your parent or 
                  guardian to complete this registration for you. You should not 
                  complete this registration yourself.
                </p>

                <p>
                  <strong>Note to parents/guardians:</strong> To create an account for the child named above, 
                  please complete the required information and provide your consent below.
                </p>

                <p>
                  We recommend that you use an email address controlled by 
                  you and not the email address of the child named above.
                </p>
              </v-flex>
            </v-layout>

            <v-layout row v-show="this.parentalConsentRequired === true">
              <v-flex xs12 pb-0>
                <v-switch
                  :label="
                    `I confirm that I am the parent/guardian of the child named above and consent to this ` +
                    configStrings.productName +
                    ` being created on their behalf.`
                  "
                  v-model="parentalConsentReceived"
                  :rules="parentalConsentReceivedRules"
                  
                ></v-switch>
              </v-flex>
            </v-layout>
            
          

            <v-layout row>
              <v-flex xs12>
                <v-text-field outline ref="pass" v-model="pass" :rules="passRules" label="Password *" type="password" required ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field outline ref="passConfirm" v-model="passConfirm" :rules="passConfirmRules" label="Confirm Password *"  type="password"  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row >
              <v-flex xs12 pb-0 id="password-notice-row">
                <p class="password-notice">A valid password must contain: <ul><li>one upper case letter</li><li>one lower case letter</li><li>a number and a special character (e.g. ^ $ * . ! @ # % &amp;) </li><li>at least 8 characters in length</li></ul></p>
              </v-flex>
            </v-layout>

            <v-layout column pb-2>
              <h2 class="heading-3">Sign for Celtic</h2>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <p class="notice">We would like to keep you updated with the latest news, offers and competitions from Celtic Park. May include Celtic FC Foundation and Celtic Pools updates.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-switch
                  :label="`Keep me updated by email`"
                  v-model="clubEmailOptIn"
                  color="success"
                  inset
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <p class="notice">Our Partners are vital to our ongoing success, please support them in the same amazing way you support us. Tick below and we'll contact you on their behalf with occasional messages. A full list is available <a href="https://www.celticfc.com/club/club-partners" target="_blank">here</a>. These may change over time. Celtic FC will NOT pass your data to any partners.</p>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex xs12 py-0>
                <v-switch
                  :label="`Receive partner offers by email`"
                  v-model="partnerOptIn"
                  color="success"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <p class="notice">If you change your mind you can unsubscribe using the button at the bottom of all Celtic FC marketing emails. We take supporters’ privacy very seriously. See our <a :href="configStrings.clubPrivacyPolicyLink" target="_blank">Privacy Policy</a> for full details on how they will use your details.</p>
              </v-flex>
            </v-layout>

            <v-layout row align-center  justify-center mx-1 py-0>
              <button type="submit" class="button" :disabled="!valid">Register</button>
            </v-layout>
            <v-layout row align-center  justify-center mx-1 py-0>
              <p class="sign-in-here">Already have an account? <router-link to="/" class="text-button">Sign in here</router-link> </p>
              
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Registration',
  data () {
    
    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required',
        v => v.length >1 || 'First name must contain at least 2 characters',
      ],
      lastNameRules: [
        v => !!v || 'Last name is required',
        v => v.length >1 || 'Last name must contain at least 2 characters',
      ],
      dobRules: [
        v => !! v || 'Date of birth is required',
        v => (this.dobYear+'-'+("0" + this.dobMonth).slice(-2)+'-'+("0" + this.dobYear).slice(-2)).toString() < new Date().toISOString().split('T')[0] || "Date can't be in the future"
      ],
      dobValidation: ['You must enter a date of birth'],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      parentalConsentReceivedRules: [
          "You must have parental/guardian consent in order to continue",
      ],
      firstName: '',
      ssoid: '',
      lastName: '',
      username: '',
      pass: '',
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      postal_code: '',
      country: '',
      clubEmailOptIn: false,
      partnerOptIn: false,
      termsAgree: true,
      passConfirm: '',
      error: null,
      loading: false,
      parentalConsentRequired: false,
      parentalConsentReceived: false,
      age: null,
      communicationString: 'Email',
      communicationStringLong: 'emails',
      countries: [],
      days: [],
      months: [],
      years: []
    }
  },
  created () {

    if(this.configValues.accountRegistrationPreferencesAreEmailOnly === false){
      this.communicationString = 'Communication'
      this.communicationStringLong = 'communications (via email, phone or mail)'
    }

    this.populateDates ()
    fetch("/countries.json")
      .then(r => r.json())
      .then(
        json => {
          this.countries = json.countries;
        },
        response => {
          console.log("Error loading json:", response);
        }
      );
  },
  computed: {
  },
  watch: {
    parentalConsentReceived: function (val, oldVal){
      this.checkForConsent();
    },
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    },
    dobDay: function (val, oldVal) {
      this.checkForConsent();
      this.validateDateOfBirth()
    },
    dobMonth: function (val, oldVal) {
      this.checkForConsent();
      this.validateDateOfBirth()
    },
    dobYear: function (val, oldVal) {
      this.checkForConsent();
      this.validateDateOfBirth()
    }
  },
  methods: {
    validateDateOfBirth() {
      // Validate date of birth fields only if all three are filled
      if (this.dobYear && this.dobMonth && this.dobDay) {

        // Optionally, you can also run the custom validation rule for date of birth
        const isValidDateOfBirth = this.isValidDate();

        if(isValidDateOfBirth){
          this.dobValidation = [true]
        } else {
          this.dobValidation = ['Date of birth not valid']
        }
      }
      return false; // Date of birth is not fully entered yet
    },
    isValidDate() {
      const dateOfBirth = new Date(this.dobYear, this.dobMonth - 1, this.dobDay); // Month is 0-based
      const currentDate = new Date();
      return dateOfBirth <= currentDate;
    },
    pad (num, size) {
      var s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    },
    getMonthAbbreviation(monthNumber) {
      const date = new Date(2000, monthNumber - 1, 1);
      const monthAbbreviation = date.toLocaleString('en-US', { month: 'short' });
      return monthAbbreviation;
    },
    checkForConsent() {
      if (this.configValues.accountConsentRequired === true) {
        //only check if this SSO requires age consent

        if (this.dobDay && this.dobMonth && this.dobYear) {
          // only check if we have a complete age in the form

          this.age = this.calculateAge(
            this.dobYear,
            this.dobMonth,
            this.dobDay
          ); // get age of the user based on the DoB fields

          if (this.age < this.configValues.accountConsentAge) {
            // if they are below the consent age then activate parental consent and opt out of marketing
            this.parentalConsentRequired = true;
            this.clubOptIn = false;
            this.partnerOptIn = false;
            console.log('user requires consent')
            if(this.parentalConsentReceived === true){
              console.log('user has consent')
              this.parentalConsentReceivedRules = [true]
            } else{
              console.log('user DOES NOT HAVE consent')
              this.parentalConsentReceivedRules = ["You must have parental/guardian consent in order to continue"]
            }
          } else {
            console.log('user doesnt need consent')
            this.parentalConsentRequired = false;
            this.parentalConsentReceivedRules = [true]
          }

          //this.$refs.form.validate();
        }
      }
    },
    populateDates () {
      // console.log('ADDING DATES')
      for(var d=1; d<32; d++){
        this.days.push(d)
      }
      for(var m=1; m<13; m++){
        var month = {
          label: this.getMonthAbbreviation(m), value:m
        }
        this.months.push(month)
      }
      var thisYear = new Date().getFullYear()
      for(var y=thisYear+1; y > 1900 ; y--) {
        this.years.push(y)
      }
    },
    crmXCMPush(username){
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API+'/user/push/'+ username
      console.log('XCM push url', crmXCMPushURL)
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username){
      console.log('completing')
      var vm = this
      this.dataPush(username)
      .then(function (results) {
        console.log('redirecting after data push')
        vm.$router.push("/post-registration-message");
      });
    },
    commsOptInText(optedIn){
      // console.log('test function called')
      if(optedIn == 'true'){
        return 'Yes please'
      } else{
        return 'No thanks'
      }
    },
    termsOptInText(optedIn){
      // console.log('test function called')
      if(optedIn == 'true'){
        return 'Yes, I have'
      } else{
        return 'No'
      }
    },
    signUp (e) {
        e.preventDefault()
        this.loading = true
        var email = this.username.toLowerCase()
        var password = this.pass
        var firstName = this.firstName
        var lastName = this.lastName
        var termsAgree = this.termsAgree.toString()
        
        var attributesList = {
            "given_name": firstName, 
            "family_name": lastName, 
            "custom:privacy_accepted": termsAgree
        }

        var address = {
          postal_code: this.postal_code,
          country: this.country
        };
        attributesList["address"] = JSON.stringify(address);

        if(this.clubEmailOptIn.toString() === 'true'){
          attributesList['custom:club_email'] = 'true'
        } else {
          attributesList['custom:club_email'] = 'false'
        }

        if(this.configValues.communitySchemeMarketingEnabled  === true){
          if(this.foundationOptIn.toString() === 'true'){
            attributesList['custom:foundation_email'] = 'true'
          } else {
            attributesList['custom:foundation_email'] = 'false'
          }
        }

        
        if(this.partnerOptIn.toString() === 'true'){
          attributesList['custom:partner_email'] = 'true'  
        } else {
          attributesList['custom:partner_email'] = 'false'
        }

        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }
        var vm = this
        this.$signUp(email, password, attributesList).subscribe((data) => {
            // console.log("sign up successful, data:", data.user)
            var username = data.user.username
            vm.complete(username)
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            if(err.message === 'An account with the given email already exists.'){
              err.message = 'This is an existing ' +this.configStrings.productName + ' account - <a href="/forgot-password" class="text-button--login-error">Please click here to reset your password</a>'
            }
            vm.error = err
        });

    }
  }
}
</script>

<style lang="scss" scoped>

    .sign-in-here{
      margin-top:20px ;
    }

    .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
  
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: $core-grey;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid $core-light-grey;
  }
  #password-notice-row {
    margin-top: 0px!important;
    padding-top: 0px!important;
  }

  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: $core-white !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:$core-lightest-grey !important;
  }

  .error {
    display: block;
  }
  .font-grey {
    color: $core-grey;
  }
  .notice {
    color: black;
    a:link {
      color: green;
    }

    /* visited link */
    a:visited {
      color: green;
    }
    
  }
</style>